import { Tour } from "nextstepjs";

const productGuide: Tour[] = [
  {
    tour: "productTour",
    steps: [
      {
        icon: null,
        title: "",
        content: "Click the heart icon to add a product to your favorites.",
        selector: "#favorite_button",
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content: "To add a product to your shopping list, click here!",
        selector: "#add_to_cart_product",
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default productGuide;
